import React from "react";
import { CustomerDisplayOrder } from "../../Interfaces/Orders";
import "./ShippingDisplay.css";
import { SHIP_TO_ORG } from "../../CommonFunctions";
import { fetchSupportEmail } from "../Forms/JoinFundraiserComponents/apiCalls";

interface CustomerDisplayOrderProps {
  order_details: CustomerDisplayOrder | null;
}

const ShippingDisplay = ({ order_details }: CustomerDisplayOrderProps) => {
  if (order_details?.order_type === "ship_to_org") {
    return (
      <div>
        <h2>Shipping to Organization</h2>
        <p>
          Your order will be given to your supported participant at the end of
          the fundraiser. Please ask your participant for exact delivery
          details.
        </p>
      </div>
    );
  }

  if (!order_details?.shipment_tracking) {
    const supportEmail = fetchSupportEmail();
    return (
      <div>
        <h2>Shipping to Customer</h2>
        <b>
          Your order is being processed and will be shipped soon. You will
          receive an email with tracking information once your order is shipped.
        </b>
        <p>
          If you have any questions or would like updates on your order status,
          please contact support at help@themakeamemoryfamily.com.
        </p>
      </div>
    );
  }

  const shipment_tracking = order_details.shipment_tracking;

  return (
    <div className="order-contents-shipping-display">
      <h3>Shipping Information</h3>

      <table className="order-contents-shipping-table">
        <tbody>
          <tr>
            <th>Tracking Number</th>
            <td data-label="Tracking Number">
              {shipment_tracking.tracking_number}
            </td>
          </tr>
          <tr>
            <th>Carrier</th>
            <td data-label="Carrier">{shipment_tracking.shipping_carrier}</td>
          </tr>
          <tr>
            <th>Estimated Delivery Date</th>
            <td data-label="Estimated Delivery Date">
              {shipment_tracking.estimated_delivery_date}
            </td>
          </tr>
        </tbody>
      </table>

      <p>
        Please note that delivery dates are estimates and are provided to us by
        the shipping carrier. For more accurate updates, please use the tracking
        number above to check the status on the carrier's website.
      </p>
    </div>
  );
};

export default ShippingDisplay;
